import { NgModule }                      from '@angular/core';
import { Routes, RouterModule }          from '@angular/router';

import { SubscriptionListComponent }     from './subscription-list.component';
import { SubscriptionDetailComponent }   from './subscription-detail.component';
import { SubscriptionSettingsComponent } from './subscription-settings.component';
import { SubscriptionUsersComponent }    from './subscription-users.component';
import { SubscriptionInvoicesComponent } from './subscription-invoices.component';
import { SubscriptionTeamsComponent }    from './subscription-teams.component';
import { SubscriptionHistoryComponent }  from './subscription-history.component';

const routes: Routes = [
  {
    path: '',
    component: SubscriptionListComponent
  },
  {
    path: ':id',
    component: SubscriptionDetailComponent,
    children: [
      {
        path: '',
        redirectTo: 'settings',
        pathMatch: 'full'
      },
      {
        path: 'settings',
        component: SubscriptionSettingsComponent
      },
      {
        path: 'users',
        component: SubscriptionUsersComponent
      },
      {
        path: 'invoices',
        component: SubscriptionInvoicesComponent
      },
      {
        path: 'teams',
        component: SubscriptionTeamsComponent
      },
      {
        path: 'history',
        component: SubscriptionHistoryComponent
      }
    ],
    data: {
      currentLevel: 1
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SubscriptionsRoutingModule { }



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscriptions-routing.module.ts